import { useState } from "react";
import * as XLSX from "xlsx";
import { addTransaction } from "../../../services/Entry/transactionService";
import "../styles/bulkUpload.css";

const BulkUpload = ({ userId, selectedPartner, showToast, setGlobalLoading }) => {
  const [loading, setLoading] = useState(false);

  const handleFileUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  if (!selectedPartner) {
    showToast("Select a partner first", "warning");
    return;
  }

  try {
    setLoading(true);
    setGlobalLoading(true);

    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);
    const sheet = workbook.Sheets[workbook.SheetNames[0]];
    const json = XLSX.utils.sheet_to_json(sheet);

    const validTransactions = [];
    const errors = [];

    json.forEach((row, index) => {
      const scrip = row.Scrip?.toString().trim();
      const date = formatExcelDate(row.Date);
      const rate = parseFloat(row.Rate);
      const quantity = parseInt(row.Quantity);
      const type = row.Type?.toString().toUpperCase();
      const amount = parseFloat(row.Amount);

      // ✅ validation rules
      if (!scrip) {
        errors.push(`Row ${index + 2}: Missing Scrip`);
        return;
      }

      if (!date) {
        errors.push(`Row ${index + 2}: Missing Date`);
        return;
      }

      if (isNaN(rate) || rate <= 0) {
        errors.push(`Row ${index + 2}: Invalid Rate`);
        return;
      }

      if (isNaN(quantity) || quantity <= 0) {
        errors.push(`Row ${index + 2}: Invalid Quantity`);
        return;
      }

      if (!type || !["BUY", "SELL"].includes(type)) {
        errors.push(`Row ${index + 2}: Invalid Type`);
        return;
      }

      // optional amount check (don’t block if missing)
      const finalAmount = isNaN(amount) ? 0 : amount;

      validTransactions.push({
        scrip: scrip.toUpperCase(),
        date,
        rate,
        quantity,
        transactionType: type,
        amount: finalAmount,
        partner: selectedPartner.name,
        createdAt: new Date()
      });
    });

    // ❌ if nothing valid
    if (validTransactions.length === 0) {
      showToast("No valid rows found in file", "error");
      return;
    }

    // 🔥 upload valid rows
    await Promise.all(
      validTransactions.map(tx =>
        addTransaction(userId, selectedPartner.id, tx)
      )
    );

    // ⚠️ show partial success warning if errors exist
    if (errors.length > 0) {
      console.warn(errors);
      showToast(
        `Uploaded ${validTransactions.length} rows with ${errors.length} errors`,
        "warning"
      );
    } else {
      showToast("All transactions uploaded successfully!", "success");
    }

  } catch (err) {
    console.error(err);
    showToast("Upload failed", "error");
  } finally {
    setLoading(false);
    setGlobalLoading(false);
  }
};

  // ✅ Excel date → yyyy-mm-dd
  const formatExcelDate = (excelDate) => {
    if (!excelDate) return "";

    if (typeof excelDate === "number") {
      const date = XLSX.SSF.parse_date_code(excelDate);
      return `${date.y}-${String(date.m).padStart(2, "0")}-${String(date.d).padStart(2, "0")}`;
    }

    return excelDate; // already string
  };

  return (
    <div className="bulk-upload">
      <label className="upload-btn">
        {loading ? "Uploading..." : "Upload Excel"}
        <input
          type="file"
          accept=".xlsx, .xls"
          onChange={handleFileUpload}
          disabled={loading}
          hidden
        />
      </label>
    </div>
  );
};

export default BulkUpload;